import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./velavu-saved-indicator.module.scss";
import { classArr } from "../helper/style-helper";
import IconCheckCircleFilled from "../dynamicicons/icon-check-circle-filled";

export interface VelavuSavedIndicatorProps {
	className?: string;
	fullWidth?: boolean;
}

/**
 * An indicator that matches the style of a VelavuButton, indicating that
 * content has been saved
 */
export default function VelavuSavedIndicator(props: VelavuSavedIndicatorProps) {
	const { t } = useTranslation();

	return (
		<div
			className={classArr(
				props.className,
				styles.indicator,
				props.fullWidth && styles.fullWidth,
			)}
		>
			<IconCheckCircleFilled color="currentColor" />
			<span>{t("common.saved")}</span>
		</div>
	);
}
